import { Navigate, Route, Routes } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import CreateEditSkill from '../../pages/create-edit-skill/CreateEditSkill';
import Home from '../../pages/dashboard/Dashboard';
import ManageSections from '../../pages/manage-sections/ManageSections';
import Page404 from '../../pages/page404/Page404';
import ProfilePage from '../../pages/profile/ProfilePage';
import RecoverPassword from '../../pages/recover-password/RecoverPassword';
import Register from '../../pages/register/Register';
import SignIn from '../../pages/signin/SignIn';
import ManageContent from '../manage-content/ManageContent';
import MyCreations from '../my-creations/MyCreations';
import Section from '../section/Section';
import SkillDetail from '../skill-detail/SkillDetail';
import Statistics from '../statistics/Statistics';

export default function AuthSwitch() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/register" element={<Register />} />
      <Route path="/recover-password" element={<RecoverPassword />} />
      <Route path="/home" element={<Home />} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-creations"
        element={
          <ProtectedRoute>
            <MyCreations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/created-skills/statistics/:skillSlug"
        element={
          <ProtectedRoute>
            <Statistics />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create-edit-skill"
        element={
          <ProtectedRoute>
            <CreateEditSkill />
          </ProtectedRoute>
        }
      />
      <Route
        path="/skills/:skillSlug/sections/edit"
        element={
          <ProtectedRoute>
            <ManageSections />
          </ProtectedRoute>
        }
      />
      <Route
        path="/skills/:skillSlug/sections/:sectionSlug/contents/edit"
        element={
          <ProtectedRoute>
            <ManageContent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/skills/:skillSlug/sections/:sectionSlug"
        element={
          <ProtectedRoute>
            <Section />
          </ProtectedRoute>
        }
      />
      <Route path="/skills/:slug" element={<SkillDetail />} />
      <Route
        path="/skills/:slug/edit"
        element={
          <ProtectedRoute>
            <CreateEditSkill />
          </ProtectedRoute>
        }
      />
      <Route element={<Page404 />} />
    </Routes>
  );
}
